import { render, staticRenderFns } from "./XNav.vue?vue&type=template&id=45d83345&scoped=true&"
import script from "./XNav.vue?vue&type=script&lang=js&"
export * from "./XNav.vue?vue&type=script&lang=js&"
import style0 from "./XNav.vue?vue&type=style&index=0&id=45d83345&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d83345",
  null
  
)

export default component.exports